export default __webpack_public_path__ + "static/media/fgraph-white.74d6e555.svg";